// src/pages/Index.tsx
import HeroSection from '@/components/HeroSection';
import SectionHeading from '@/components/SectionHeading';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ScrollToTop from '@/components/ScrollToTop';
import TestimonialsCarousel from '@/components/TestimonialsCarousel';
import AboutSection from '@/components/AboutSection';
import OfferSection from '@/components/OfferSection';
import TeamSection from '@/components/TeamSection';

const Index = () => {
  const features = [
    {
      title: 'Keramika',
      description: 'Široka izbira keramičnih ploščic za vsak prostor.',
      imageSrc: 'https://images.unsplash.com/photo-1585421514738-01798e348b17?q=80&w=2070',
      link: '/keramika'
    },
    {
      title: 'Kamen',
      description: 'Naravni kamen za trajno lepoto vašega doma.',
      imageSrc: 'https://images.unsplash.com/photo-1588345921523-c2dcdb7f1dcd?q=80&w=2070',
      link: '/kamen'
    },
    {
      title: 'Pulti',
      description: 'Visokokakovostni pulti za kuhinjo in kopalnico.',
      imageSrc: 'https://images.unsplash.com/photo-1609766857041-ed402ea8e2b2?q=80&w=2070',
      link: '/pulti'
    },
    {
      title: 'Storitve',
      description: 'Profesionalne storitve in strokovna izvedba.',
      imageSrc: 'https://images.unsplash.com/photo-1581092160607-ee22621dd758?q=80&w=2070',
      link: '/storitve'
    }
  ];

  const metricsCards = [
    {
      value: "30+",
      label: "Let izkušenj"
    },
    {
      value: "1000+",
      label: "Zadovoljnih strank"
    },
    {
      value: "5000+",
      label: "Izvedenih projektov"
    },
    {
      value: "100%",
      label: "Predanost kakovosti"
    }
  ];

  const teamMembers = [
    {
      name: "Marko Novak",
      position: "Direktor (CEO)",
      bio: "Več kot 15 let izkušenj v industriji. Specializiran za strateški razvoj in vodenje podjetja.",
      image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=2070"
    },
    {
      name: "Andreja Kovač",
      position: "Finančna direktorica (CFO)",
      bio: "Strokovnjakinja za finančno upravljanje z bogatimi izkušnjami v gradbenem sektorju.",
      image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?q=80&w=2076"
    },
    {
      name: "Matej Horvat",
      position: "Vodja prodaje",
      bio: "Strokovnjak za prodajo s posebnim znanjem o naravnih kamnih in njihovi uporabi.",
      image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?q=80&w=2074"
    },
    {
      name: "Nina Zupan",
      position: "Prodajni svetovalec",
      bio: "Specializirana za keramiko in svetovanje strankam pri izbiri najboljših materialov za njihove projekte.",
      image: "https://images.unsplash.com/photo-1580489944761-15a19d654956?q=80&w=2061"
    },
    {
      name: "Luka Krajnc",
      position: "Prodajni svetovalec",
      bio: "Več kot 8 let izkušenj pri delu s strankami in svetovanje pri izbiri materialov za pult.",
      image: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?q=80&w=2070"
    }
  ];

  return (
    <div className="min-h-screen">
      <Navbar />
      <ScrollToTop />
      
      <main>
        <HeroSection 
          title="Kamen d.o.o. - Keramika, kamen in pulti za vaš dom"
          subtitle="Kakovostni materiali in strokovna izvedba za vaš dom"
          imageSrc="https://images.unsplash.com/photo-1600585152220-90363fe7e115?q=80&w=2070"
        />

        {/* About Us Section with Metrics side by side */}
        <section className="py-16">
          <div className="container-custom">
            <SectionHeading 
              title="Dobrodošli pri Kamen d.o.o."
              subtitle="Vaš partner za vrhunske materiale in storitve od leta 1990."
            />
            
            <AboutSection metricsCards={metricsCards} />
          </div>
        </section>

        {/* Our Offer Section */}
        <section className="py-16 bg-gray-50">
          <div className="container-custom">
            <SectionHeading 
              title="Naša ponudba"
              subtitle="Odkrijte visokokakovostne materiale za vaš dom"
            />
            
            <OfferSection features={features} />
          </div>
        </section>
        
        {/* Ekipa Section */}
        <section className="py-16">
          <div className="container-custom">
            <SectionHeading 
              title="Naša ekipa"
              subtitle="Spoznajte strokovnjake, ki stojijo za našimi storitvami"
            />
            
            <TeamSection teamMembers={teamMembers} />
          </div>
        </section>
        
        {/* Testimonials Section */}
        <section className="py-16 bg-gray-50">
          <div className="container-custom">
            <SectionHeading 
              title="Mnenja naših strank"
              subtitle="Kaj pravijo naši zadovoljni stranke o naših storitvah in izdelkih"
            />
            
            <TestimonialsCarousel />
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default Index;